import * as React from 'react';

function SvgViewLeaderboard(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={6.811} height={11.593} {...props}>
      <g data-name="Group 17">
        <path
          d="M4.522 5.8L.185 1.462a.636.636 0 010-.9l.38-.38a.635.635 0 01.9 0l5.161 5.167a.64.64 0 010 .9l-5.159 5.159a.636.636 0 01-.9 0l-.38-.38a.635.635 0 010-.9z"
          data-name="Path 138"
          fill={props.fill}
        />
      </g>
    </svg>
  );
}

export default SvgViewLeaderboard;
